export const PAGES_API_CALL_BEGIN = 'PAGES_API_CALL_BEGIN';
export const PAGES_API_CALL_SUCCESS = 'PAGES_API_CALL_SUCCESS';
export const PAGES_API_CALL_FAILURE = 'PAGES_API_CALL_FAILURE';
export const PAGES_API_CALL_DISMISS_ERROR = 'PAGES_API_CALL_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/pages/redux/constants.js